/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/prop-types
import PropTypes from 'prop-types';
// oxlint-disable-next-line typescript/ban-ts-comment
// @ts-ignore json imports are ts-ignored
import supportedLocales from './supported-locales.json';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { defaultLocale, supportedLanguagesMap } from './constants';

export const localePropType: PropTypes.Requireable<string> = PropTypes.oneOf(
	Object.keys(supportedLocales),
);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export {
	getLocale,
	formatTimezonedWithLocale,
	floatDifferenceOfDates,
	formatWithLocale,
	formatDistanceWithLocale,
	formatRelativeWithLocale,
	formatDistanceStrictWithLocale,
	weekStartDayWithLocale,
	formatZonedDateTimeWithZone,
	parseZoneDateTime,
	setTimezoneOffset,
	setNumberOffsetToISODate,
	formatDateStringToISO,
	isValidTimeZone,
} from './main';
